import { ReactComponent as BreathingExercises } from "@icons/breathing-exercises.svg";
import { ReactComponent as FourWeekPlans } from "@icons/four-week-plans.svg";
import { ReactComponent as HealthChecks } from "@icons/health-checks.svg";
import { ProtectedModule } from "core/auth/accessControl/ProtectedModule/ProtectedModule";
import { ResourceTile } from "../ResourceTile";
import { WisdomModules } from "shared/constants/Modules";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

export const WellbeingToolTiles = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-row justify-around w-full gap-2 h-fit md:gap-4">
      <ProtectedModule
        wisdomModule={WisdomModules.fourWeekPlan}
        moduleComponent={
          <ResourceTile
            title={t("resources.fourWeekPlanLinkName")}
            ariaLabel={t("resources.fourWeekPlanNavigationLabel")}
            ResourceIcon={FourWeekPlans}
            onClick={() => navigate("/4-week-plans")}
          />
        }
      />
      <ProtectedModule
        wisdomModule={WisdomModules.miniHealthChecks}
        moduleComponent={
          <ResourceTile
            title={t("resources.healthCheckLinkName")}
            ariaLabel={t("resources.healthCheckNavigationLabel")}
            ResourceIcon={HealthChecks}
            onClick={() => navigate("/mini-health-checks")}
          />
        }
      />
      <ResourceTile
        title={t("resources.breathingExercisesLinkName")}
        ariaLabel={t("resources.breathingExercisesNavigationLabel")}
        ResourceIcon={BreathingExercises}
        onClick={() => navigate("/breathing-exercises")}
      />
    </div>
  );
};
